"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.run = exports.AbortError = void 0;
const retry_1 = __importDefault(require("retry"));
class AbortError extends Error {
    originalError;
    constructor(message) {
        super();
        if (message instanceof Error) {
            this.originalError = message;
            ({ message } = message);
        }
        else {
            this.originalError = new Error(message);
            this.originalError.stack = this.stack;
        }
        this.name = "AbortError";
        this.message = message;
    }
}
exports.AbortError = AbortError;
function decorateErrorWithCounts(error, attemptNumber, retries) {
    // Minus 1 from attemptNumber because the first attempt does not count as a retry
    const retriesLeft = retries - (attemptNumber - 1);
    const decoratedError = error;
    decoratedError.attemptNumber = attemptNumber;
    decoratedError.retriesLeft = retriesLeft;
    return decoratedError;
}
/**
 * Runs a promise callback and retries it according to the provided retry configuration until it succeeds or
 * has used up all it's retry attempts, you can also abort early using the pRetry.AbortError
 * */
function run(input, options = {}) {
    return new Promise((resolve, reject) => {
        const retries = options.retries ?? 10;
        const operation = retry_1.default.operation({
            retries,
            factor: options.factor ?? 2,
            minTimeout: options.minTimeout ?? 1000,
            maxTimeout: options.maxTimeout ?? 10000,
            randomize: options.randomize ?? true,
        });
        operation.attempt(async (attemptNumber) => {
            try {
                resolve(await input(attemptNumber));
            }
            catch (error) {
                if (!(error instanceof Error)) {
                    reject(new TypeError(`Non-error was thrown: "${error}". You should only throw errors.`));
                    return;
                }
                const isAbortError = error instanceof AbortError;
                decorateErrorWithCounts(error, attemptNumber, retries);
                try {
                    if (options.onFailedAttempt) {
                        await options.onFailedAttempt(error);
                    }
                }
                catch (error) {
                    reject(error);
                    return;
                }
                if (isAbortError) {
                    reject(error);
                    operation.stop();
                    return;
                }
                // operation.retry returns true if it scheduled another attempt
                if (!operation.retry(error)) {
                    reject(operation.mainError());
                }
            }
        });
    });
}
exports.run = run;
//# sourceMappingURL=data:application/json;base64,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